import styled from 'styled-components';

export const StyledAboutCtaSection = styled.div`
  .about-cta-section {
    width: 100%;
    padding: 80px 16px 120px;

    &__inner {
      margin: 0 auto;
      max-width: 800px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: 20px;

      p {
        color: ${({ theme }) => theme.colors.boulder};
        max-width: 500px;
      }

      button {
        margin-top: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
      }
    }
  }
`;
